//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Malinas_info",
  data() {
    return {
    };
  },
  components: {
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  }
};



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/ObGyn/Malinas_info.vue